<template>
  <div class="popup-wrapper" >
    <div class="popup-overlay" @click="$emit('closePopup')"></div>
    <div class="popup popup--idea-pic">
      <button class="popup-close" @click="$emit('closePopup')"></button>
      <span class="popup-title">Choose main picture</span>
      <Selector
          id="imagecategory"
          filterKey="imagecategory"
          :selectorOptions="imagesCategories"
          :options="{
                  isMultiple: false
                }"
          @change="(val) => {imageCategory = val[0].value; getImages()}"
      ></Selector>
      <div class="form-block--pic-radios">
        <div class="radios-wrapper">
          <div class="pic-radio-upload-wrapper" v-if="!uploadedPhoto.idFile">
            <div class="pic-radio-upload-before">
              <label for="upload-new-cover-win" class="button-icon">Upload <i class="icon-upload"></i></label>
              <input id="upload-new-cover-win" ref="photo" type="file" accept="image/*" name="upload-new-cover" @change="uploadPhoto()">
            </div>
          </div>

          <label v-if="uploadedPhoto.idFile" class="pic-radio pic-radio-wrapper">
            <input type="radio" name="add-new-cover" :value="uploadedPhoto.idFile" @click="$emit('selectPhoto', uploadedPhoto)">
            <span class="pic-radio-img">
                  <span :style="`background-image:url(${imageUrl}/${uploadedPhoto.idFile});`" />
                  <button class="pic-radio-remove" @click="uploadedPhoto = {}"><i class="icon-remove"></i></button>
                </span>
          </label>

          <span class="pic-radio-wrapper" v-for="(cover) in covers" :key="`cover-${cover}`">
                <label class="pic-radio">
                  <input type="radio" name="add-new-cover" :value="cover" @click="$emit('selectPhoto', cover)">
                  <span class="pic-radio-img">
                    <span :style="`background-image:url(https://engage.edge.capgemini.com/${cover});`" />
                  </span>
                </label>
              </span>
        </div>

        <div class="slider-nav">
          <button class="slider-prev" :class="{'inactive': coverPage === 0}" @click="coverPage--"></button>
          <ul class="slider-paginator">
            <li v-for="i in coverMaxPages" :key="`paginator-${i}`" :class="{active: (i-1) === coverPage}" @click="coverPage = i" ></li>
          </ul>
          <button class="slider-next" @click="coverPage++" :class="{'inactive': coverPage >= coverMaxPages}"></button>
        </div>
      </div>

      <div class="form-bottom">
        <button class="link" @click="$emit('closePopup')"><span>Back to edit</span></button>
        <button class="button-icon button--submit" @click="$emit('selectCover')">Done <i class="icon-check"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import Selector from "@/components/forms/Selector";
import files from "@/api/files";
import settings from "@/settings";
export default {
  name: "CoverImagePopup",
  components: {Selector},
  data() {
    return {
      imageCategory: '01e99a552d113a3bf046e2cc78a46214',
      uploadedPhoto: {},
      uploadingImage: true,
      coverPage: 0,
      imageUrl: `${settings.API_BASE_PATH}/image`
    }
  },
  computed: {
    coverMaxPages() {
      return Math.round(this.$store.getters.defaultImages.length/7)
    },
    covers() {
      return this.$store.getters.defaultImages.slice(this.coverPage*7, this.coverPage*7+7);
    },
    imagesCategories() {
      let categories = [];
      this.$store.getters.imageCategories.forEach(item => {
        categories.push({
          id: item.idSettingGlobal,
          name: item.value,
          value: item.idSettingGlobal,
          active: item.idSettingGlobal === this.imageCategory,
        })
      })
      return categories;
    },
  },
  methods: {
    getImages() {
      this.$store.dispatch('getDefaultImagesPerCategory', {
        id_category: this.imageCategory,
        id_company: this.$store.getters.selectedCompanyId
      })
      this.coverPage = 0;
    },
    uploadPhoto () {
      this.uploadingImage = true
      let file = this.$refs.photo.files[0]
      files.addFile(file, (data) => {
        this.uploadedPhoto = data
        this.uploadingImage = false
      })
    },
  }
}
</script>

<style scoped>

</style>